import styled from 'styled-components';

const DavidStoreInsertsStyled = styled.div`
    .order-inserts-container {
        background-color: #ec008c;
        display: flex;
        justify-content: space-between;
        border-radius: 8px;
        padding: 16px 12px;
    }
    .order-inserts-description {
        display: flex;
        gap: 10px;
    }
    .description-style {
        color: white;
        margin: 0;
        color: var(--Main-Brand-Basics-White, #fff);
        font-family: 'Objektiv Mk2 Bold';
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 27px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
    }
    .icon-style {
        color: white;
        width: 24px;
        height: 24px;
        margin-top: 3px;
    }
`;

export { DavidStoreInsertsStyled };
